<template>
  <el-form
    ref="emailForgotForm"
    :model="form.field"
    status-icon
    :validate-on-rule-change="false"
    label-width="80px"
    :show-message="false"
  >
    <el-form-item
      required
      prop="email"
      :label="$t('cmsg.email')"
      :error="form.errors.Username"
      :rules="[
        {required: true,message:$t('cmsg.required')},
        {type: 'email',message:$t('cmsg.emailRequired')}
        ]"
    >
      <el-input
        v-model="form.field.email"
        type="email"
        :placeholder="$t('cmsg.email')"
        @keyup.enter.native="onSubmit"
      ></el-input>
    </el-form-item>
    <el-form-item
      required
      prop="captcha"
      :label="$t('cmsg.captcha')"
      :error="form.errors.Captcha"
      :rules="[
        {required: true,message:$t('cmsg.required')}
        ]"
    >
      <el-input v-model="form.field.captcha" @keyup.enter.native="onSubmit">
        <el-button slot="prepend" class="captcha_img" @click="new_captcha">
          <img :src="form.captcha_img" v-if="form.captcha_img">
        </el-button>
      </el-input>
    </el-form-item>
    <br>
    <p style="text-align: left;">{{$t('cmsg.forgotEmailHint')}}</p>
    <!-- <p class="bg-danger" v-if="form.err">{{form.err}}</p> -->
    <el-form-item>
      <el-button
        type="primary"
        @click="onSubmit"
        class="submit_btn"
        :loading="form.loading"
      >{{$t('cmsg.submit')}}</el-button>
    </el-form-item>
    <p style="text-align: left;">
      {{$t('cmsg.orBackTo')}}
      <router-link :to="{name:'login'}">
        <el-button type="text">{{$t('cmsg.loginBtn')}}</el-button>
      </router-link>
    </p>
  </el-form>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "email-login",
  components: {},
  data() {
    return {
      form: {
        captcha_img: "",
        field: {
          uuid: "",
          email: "",
          lang: Cookies.get("lang") || "cn",
          captcha: "",
          resetURL: ""
        },
        errors: {
          Username: "",
          Captcha: ""
        },
        loading: false,
        err: ""
      }
    };
  },
  methods: {
    onSubmit() {
      this.form.err = "";
      // var vueObj = this;
      this.$refs["emailForgotForm"].validate(valid => {
        if (valid) {
          this.form.loading = true;
          //   console.log(this.form.field);
          let props = this.$router.resolve({
            name: "resetpwbe",
            query: {
              email: this.form.field.email,
              uuid: this.form.field.uuid,
              captcha: this.form.field.captcha
            }
          });
          // console.log(props);
          this.form.field.resetURL =
            window.location.protocol + "//" + window.location.host + props.href;
          this.$axios
            .post(`/api/f/e`, this.form.field, {
              json: true,
              validateStatus: function(status) {
                return status >= 200 && status < 404; // default
              }
            })
            .then(res => {
              // console.log("res: ", res.data.result.perms);
              if (res.data && res.data.status === "success") {
                // this.perms = res.data.result.perms;
                // this.$store.dispatch("SetPerm",res.data.result.perms);
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.successAction")
                });
                var t = this;
                setTimeout(function() {
                  // window.location = t.$router.resolve({
                  //   name: "enIndex"
                  // }).href;
                  t.$redirect({ name: "login" });
                  // this.$router.push({name:"cases"});
                }, 3000);
              } else {
                this.form.loading = false;
                this.form.err = res.data.result;
                var ermsg = {};
                var fs = [];
                try {
                  ermsg = JSON.parse(res.data.result);
                } catch (e) {
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.form.errors[erk] = this.$t("cmsg.errField");
                  fs.push(erk);
                });
                this.form.err = res.data.result;
                this.$message({
                  type: "error",
                  duration:0,
                  showClose:true,
                  message: fs.join(",")+this.$t("cmsg.errField")
                });
              }
            })
            .catch(err => {
              console.log("err: ", err);
              this.form.err = this.$t("cmsg.mting");
              this.form.loading = false;
            });
        } else {
          this.form.loading = false;
          return false;
        }
      });
    },
    new_captcha() {
      this.$axios
        .get(
          `/api/captcha/${this.$gf.uuid()}?w=180&h=31&p=ef-${pub.loginSdk}&e=86400`,
          {
            validateStatus: function(status) {
              return status >= 200 && status < 404; // default
            }
          }
        )
        .then(res => {
          if (
            res &&
            res.data &&
            res.data.result &&
            res.data.status === "success"
          ) {
            this.form.captcha_img = res.data.result;
          } else {
            this.form.captcha_img = "";
          }
        });
    }
  },
  mounted() {
    // console.log();
    this.form.field.uuid = "ef-" + pub.loginSdk + "-" + this.$gf.uuid();
    this.new_captcha();
  }
};
</script>
<style>
.el-form-item:not(:nth-last-of-type(1)) {
  margin-bottom: 0px;
}
.el-form-item:first-of-type {
  margin-bottom: 20px;
}
.submit_btn {
  width: 100%;
}
.el-input-group__prepend {
  padding: 0px !important;
}
.captcha_img {
  /* width: 180px; */
  padding: 0px !important;
  margin: 0px !important;
}
</style>
